// «Prueba en vivo»: the team plays the prospect in the app; LIA's actions on the CRM are real. Schemas: api-live-test.ts.
import * as L from './api-live-test.js';
import { IdParam, route, W, Ws } from './route-def.js';

const Test = W({ conversationId: IdParam });

export const liveTestRoutes = {
  listLiveTests: route({
    method: 'GET', path: '/workspaces/:workspaceId/live-tests', summary: 'Pruebas en vivo del espacio', tag: 'live-tests',
    minRole: 'manager', params: Ws, response: L.LiveTestListSchema,
  }),
  startLiveTest: route({
    method: 'POST', path: '/workspaces/:workspaceId/live-tests', summary: 'Iniciar una prueba en vivo con un lead existente del CRM o uno nuevo (auditado)', tag: 'live-tests',
    minRole: 'manager', params: Ws, body: L.StartLiveTestSchema, response: L.LiveTestSchema, status: 201,
  }),
  sendLiveTestMessage: route({
    method: 'POST', path: '/workspaces/:workspaceId/live-tests/:conversationId/messages', summary: 'Escribir como el prospecto en la prueba en vivo', tag: 'live-tests',
    minRole: 'manager', params: Test, body: L.LiveTestMessageSchema, response: L.LiveTestSchema,
  }),
  advanceLiveTest: route({
    method: 'POST', path: '/workspaces/:workspaceId/live-tests/:conversationId/advance', summary: 'Ejecutar ahora la siguiente tarea de LIA en la prueba', tag: 'live-tests',
    minRole: 'manager', params: Test, response: L.LiveTestAdvanceResultSchema,
  }),
  endLiveTest: route({
    method: 'POST', path: '/workspaces/:workspaceId/live-tests/:conversationId/end', summary: 'Terminar la prueba en vivo (auditado)', tag: 'live-tests',
    minRole: 'manager', params: Test, response: L.LiveTestSchema,
  }),
  searchCrmContacts: route({
    method: 'GET', path: '/workspaces/:workspaceId/crm/connections/:connectionId/contacts', summary: 'Buscar contactos del CRM (para elegir un lead de prueba)', tag: 'live-tests',
    minRole: 'manager', params: W({ connectionId: IdParam }), query: L.CrmContactSearchQuerySchema, response: L.CrmContactHitsSchema,
  }),
} as const;
